import { COUNTRIES } from "./countries"

export const countries = COUNTRIES.map((v) => ({
  title: v.titleEn !== v.title ? `${v.titleEn} - ${v.title}` : v.titleEn,
  value: v.value,
}))

export const trainingFrequencies = [
  { title: 'ほぼ毎日', value: 'ALMOST_EVERY_DAY' },
  { title: '週に2~3日程度', value: 'ABOUT_2_3_DAYS_A_WEEK' },
  { title: '週に1回程度', value: 'ABOUT_ONCE_A_WEEK' },
  { title: '月に1〜2回程度', value: 'ABOUT_1_2_TIMES_A_MONTH' },
  { title: '気が向いた時', value: 'WHENEVER_I_FEEL_LIKE_IT' },
  { title: 'ほどんどしていない', value: 'ALMOST_NEVER' },
  { title: 'まったくしていない', value: 'NEVER' },
  { title: 'どれにも当てはまらない', value: 'NONE_OF_THE_ABOVE' },
]

export const trainingPurposes = [
  { title: '五輪、世界選手権に出場したい', value: 'OLYMPICS_WORLD_CHAMPIONSHIP' },
  { title: 'レースで優勝したい', value: 'WIN_RACE' },
  { title: 'レースで入賞したい', value: 'PLACE_IN_RACE' },
  { title: 'レースに出場したい', value: 'COMPETE_IN_RACE' },
  { title: 'ランニングを継続したい', value: 'CONTINUE_RUNNING' },
  { title: 'Well-beingでいたい', value: 'WELL_BEING' },
  { title: '健康になりたい', value: 'HEALTHY' },
  { title: '痩せたい', value: 'LOSE_WEIGHT' },
  { title: '特にない', value: 'NOTHING_IN_PARTICULAR' },
  { title: 'どれでもない', value: 'NONE_OF_THESE' },
  { title: 'その他', value: 'OTHER' },
]

export const events = [
  { title: '100m', value: '100M' },
  { title: '200m', value: '200M' },
  { title: '400m', value: '400M' },
  { title: '800m', value: '800M' },
  { title: '1000m', value: '1000M' },
  { title: '1500m', value: '1500M' },
  { title: '3000m', value: '3000M' },
  { title: '5000m', value: '5000M' },
  { title: '10000m', value: '10000M' },
  { title: 'ハーフマラソン', value: 'HALF_MARATHON' },
  { title: 'フルマラソン', value: 'FULL_MARATHON' },
  { title: '50km', value: '50KM' },
  { title: '100km', value: '100KM' },
  { title: 'トレランXL(100 miles)', value: '165KM' },
  { title: 'トレランS(~50km)', value: 'TRAIL_RUNNING_S' },
  { title: 'トレランM(~80km)', value: 'TRAIL_RUNNING_M' },
  { title: 'トレランL(~120km)', value: 'TRAIL_RUNNING_L' },
  { title: 'トレランXL(120km~)', value: 'TRAIL_RUNNING_XL' },
  { title: 'その他', value: 'OTHER' },
]
